import { useMemo } from 'react';
import { ExistingCitationsTableRowData, SelectCitations } from './SelectCitations';
import { createCitationsColumns } from '../utils/tableColumns';
import { useUpdateExistingCitations } from '../hooks';
import { Box, Button, Typography } from '@mui/material';
import { removeAllButtonSx } from '../styles';
import { addToOrderButtonSx } from './SyncAndPost';

// Constants
const TITLE = 'Update Existing Citations';
const DESCRIPTION =
  'Based on your chosen citations, we have preselected the most authoritative sites.';

export const UpdateExistingCitations = () => {
  // Memoized table columns
  const columns = useMemo(() => createCitationsColumns(), []);

  // Use custom hook for all business logic
  const {
    tableData,
    selected,
    totalPrice,
    orderBy,
    order,
    handleSelect,
    handleSelectMultiple,
    handleSelectAll,
    handleRemoveAll,
    handleRequestSort,
    getRowId
  } = useUpdateExistingCitations();

  return (
    <SelectCitations<ExistingCitationsTableRowData>
      title={TITLE}
      description={DESCRIPTION}
      data={tableData}
      columns={columns}
      selected={selected}
      totalPrice={totalPrice}
      onSelect={handleSelect}
      onSelectMultiple={handleSelectMultiple}
      onSelectAll={handleSelectAll}
      onRemoveAll={handleRemoveAll}
      orderBy={orderBy}
      order={order}
      onSort={handleRequestSort}
      getRowId={getRowId}
      actionButton={() => {
        // Check if all items are selected
        const allSelected = tableData.length > 0 && selected.length === tableData.length;

        if (allSelected) {
          return (
            <Button
              variant="outlined"
              color="primary"
              onClick={handleRemoveAll}
              sx={removeAllButtonSx}
            >
              Remove All
            </Button>
          );
        }

        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // Create a synthetic ChangeEvent for handleSelectAll
              const syntheticEvent = {
                target: { checked: true }
              } as React.ChangeEvent<HTMLInputElement>;
              handleSelectAll(syntheticEvent);
            }}
            sx={addToOrderButtonSx}
          >
            Add To Order
          </Button>
        );
      }}
      noDataFallbackUI={() => {
        return (
          <Box sx={{
            textAlign: 'center',
          }}>
            <Typography>No existing citations found</Typography>
          </Box>
        );
      }}
    />
  );
};

